// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__dTMK9","text":"styles_text__ZTOw2","containerclassName":"styles_containerclassName__zzW24","imageBorder":"styles_imageBorder__dQxuq"};